import api from './api';
import { LocationListApiResponse, LocationOption } from '../types/location';

const toArray = (payload: any): any[] => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.items)) return payload.items;
    if (Array.isArray(payload?.countries)) return payload.countries;
    if (Array.isArray(payload?.states)) return payload.states;
    if (Array.isArray(payload?.cities)) return payload.cities;
    if (Array.isArray(payload?.result)) return payload.result;
    return [];
};

const normalizeLocations = (input: any[]): LocationOption[] => {
    return input.map((item: any) => ({
        id: String(item.id || item._id || ''),
        name: String(item.name || ''),
        code: item.code,
        countryId: item.countryId ? String(item.countryId) : undefined,
        stateId: item.stateId ? String(item.stateId) : undefined,
        isActive: item.isActive,
    })).filter((item) => item.id && item.name);
};

export const locationService = {
    getCountries: async (): Promise<LocationOption[]> => {
        const response = await api.get<LocationListApiResponse>('location/countries');
        return normalizeLocations(toArray(response.data?.data ?? response.data));
    },

    getStatesByCountry: async (countryId: string): Promise<LocationOption[]> => {
        const response = await api.get<LocationListApiResponse>(`location/states/${countryId}`);
        return normalizeLocations(toArray(response.data?.data ?? response.data));
    },

    getCitiesByState: async (stateId: string): Promise<LocationOption[]> => {
        const response = await api.get<LocationListApiResponse>(`location/cities/${stateId}`);
        return normalizeLocations(toArray(response.data?.data ?? response.data));
    },
};
